/* eslint-disable prefer-template */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return, no-param-reassign */
import axios from "axios";
import { API_URL } from "../../components/constants/index";
import {
    createStore,
    createHook,
    createContainer,
    createSubscriber,
} from "react-sweet-state";

const StoreStaked = createStore({
    initialState: {

    },
    actions: {
        updateStaked:
            (params) =>
                ({ getState, setState }) => {
                    return new Promise((resolve, reject) => {
                        axios.post(`${API_URL}/pool/staked`, { ...params }).then((res) => {

                            resolve(res)
                        });
                    });
                },
        callNoti:
            (params) =>
                ({ getState, setState }) => {
                    return new Promise((resolve, reject) => {
                        axios.post(`https://noti-tnx-bot-dev.metatech.foundation/stake/message`, { ...params }).then((res) => {

                            resolve(res)
                        });
                    });
                },
        getPoolDetail:
            (keyword) =>
                async ({ setState }) => {
                    try {
                        const res = await axios.get(
                            `${API_URL}/pool/launch-pool-detail?keywork=${keyword}`
                        );
                        return res.data.data;
                    } catch (err) { }
                },
    },
    name: "StoreStaked",
});

export const useHookStaked = createHook(StoreStaked);
export const Container = createContainer(StoreStaked, {
    onInit:
        () =>
            ({ setState }, props) => {
                setState({ ...props });
            },
});
export const Subscriber = createSubscriber(StoreStaked);
